
// © Microsoft Corporation. All rights reserved.

export enum ChildExperiencesDeferRenderType {
    /**
     * Wait for all child experinces milestone load dependecies to be resolved, once all child experiences are loaded and available
     * triggers parent re-render. Best from perfomance standpoint as it does a single re-render of parent
     */
    batch = "batch",

    /**
     * Render every child experince as soon as its available after milestone load dependecies has been resolved, This is less performant as it triggers
     * parent re-render multiple times for each delay loaded child experience
     */
    renderWhenAvailable = "renderWhenAvailable"
}